import React, { useState, useContext, useEffect } from "react";
import { detectUserType } from '../utils/koa-common';
import { TextField, Button, Container, Box, Grid, Paper, Link, AppBar, Toolbar, Typography, Tooltip, FormControl, FormControlLabel, Avatar, Input, InputLabel, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import FooterBar from './footer_bar';
import BrowserNotice from './browser-notice';
import useStyles from '../pages/Gui/gui'
import { createTheme, ThemeProvider, Theme } from "@mui/material/styles";
import { login_axios, logout_axios } from "../services/auth-service";
import AuthContext, { LoginPayload, useAuth, UserType } from "../contexts/AuthContext";
import { Redirect, RouteComponentProps } from "react-router";
import { render } from "@testing-library/react";

import ReactGA from 'react-ga4';
import axios, { reduceApiPayload } from '../api/axios'
import { replace } from "lodash";

type Props = {
  history: RouteComponentProps['history']
}

const DownloadNotice = () => {
  const [open, setOpen] = React.useState(true);
    const handleClickOpen = () => {
      setOpen(true);
  };

  const handleClose = () => {
      setOpen(false);
  };

  return (
    <div>
          {/* <Button endIcon={<RefreshIcon />} variant="contained" sx={{ marginLeft: '1em' }} size="small" onClick={handleClickOpen}>Start Session</Button> */}
          <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
          >
              <DialogTitle id="alert-dialog-title">
                  {"Download Prerequisites"}
              </DialogTitle>
              <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                  {"This initiates a download to your browsers default download folder, so we advice that you create a download location where you would like to have all your data stored prior to logging into the gui. Additionally if your browser requires that you acknowledge every download you may need to disable this to prevent a download prompt when each new row is received."}
                  <br/>
                  {"Are you ready?"}
                  </DialogContentText>
              </DialogContent>
              <DialogActions>
                  <Link href='/download_help'>Tell Me More</Link>
                  <Button onClick={handleClose} autoFocus>
                      Yes
                  </Button>
              </DialogActions>
          </Dialog>
      </div>
  )
}

const Login = ({history} : Props) => {
  const [t_userid, setUserid] = useState("");
  const [t_password, setPassword] = useState("");
  const [t_usertype, setUserType] = useState("");
  const [t_autherror, setAuthError] = useState(true);
  const [t_errormsg, setErrorMsg] = useState("");
  const [t_authres, setAuthRes] = useState({"error": false, "message": ""});


  const { loading, setLoading, loggedIn, roles, token, user, watchDate, refreshtoken, setRefreshToken, storesession, set_localsession } = useAuth()
  const ENDPOINTS_TOKEN = `${process.env.REACT_APP_API_TOKEN}`
  async function handleLoginSubmit(e: React.FormEvent) {
    e.preventDefault();
    // To Disable multiple clicks and dispaly spinner
    setLoading(true);

    axios.post(ENDPOINTS_TOKEN, JSON.stringify({'userid': t_userid, 'password': t_password, 'watchdate': watchDate}), {
      headers: { "Content-Type": "application/json"},
      // withCredentials: true
    }).then((data_:any) => {
      setLoading(false)
      const reduced_res_:LoginPayload = reduceApiPayload(data_.data) ?? {};
      setRefreshToken(data_.data.refresh_token)
      set_localsession(reduced_res_)
      storesession(reduced_res_)

      ReactGA.event('Login');
      ReactGA.event('Successful_Login', {
         'event_category': 'KOA_Login',
         'event_label': `${t_userid}`,
         'value': 1   
      });
      ReactGA.set({'userid':t_userid});
      ReactGA.set({'observation_date':watchDate });
    }).catch( (err)=> {
      console.log(err)
      setLoading(false)
      setAuthRes(err)
      setErrorMsg('Login Failed, check your credentials')
      ReactGA.event('Failed_Login', {
         'event_category': 'KOA_Login',
         'event_label': `${t_userid}`,
         'value': 0   
      });
    });
  };


  const openDownloadNotice = () => {
    render(<>
      <DownloadNotice />
    </>)
  }

  if (!loggedIn) {
       ReactGA.send({hitType: 'pageview', page: `/rti-gui/login`, title: 'ODAP - Login'});
  }
  return (
    ( loggedIn ?
      ( <Redirect to='/gui' />):
      <>
        <main style={{ height: '100%' }}>
          <CssBaseline />
          <Grid container>
            <Paper elevation={3} sx={{ width: '85%', padding: '15vh 10vh', margin: 'auto', display: 'flex', justifyContent: 'center', marginBottom: 'calc(100vh - 45%)' }}>
              <Container sx={{ width: '60%' }}>
                {/* <Typography component="h1" variant="h5">Sign In</Typography> */}
                <div className="column left">
                  <h1 className="title is-1 has-text-white-ter">Observers' Data Access Portal Login</h1>
                  <h2 className="subtitle colored is-4">Restricted access.</h2>
                  <p>Welcome to the Observer's Data Access Portal. Keck observers can use this Portal to manage and download data acquired at the telescope and ingested in near real time into KOA. Logon on to see all the programs you are authorized to access during the current night. If you cannot log on, cannot see all your authorized programs, or  have any other issue, send a message to the KOA Help desk by <Link href="https://koa.ipac.caltech.edu/cgi-bin/Helpdesk/nph-genTicketForm?projname=KOA">Clicking Here</Link> or message <Link href="mailto:koa-servicedesk@ipac.caltech.edu">koa-servicedesk@ipac.caltech.edu</Link>.</p>
                  <p>Please read up on how to setup your browser to properly utilize the Portal <Link href="/UserGuide/odap_help.html">here</Link>.</p>
                  {/* <p><Link href="#">Sign Up</Link></p> */}
                </div>
                <div style={{ fontSize: '.8em', color: 'grey' }}>
                  <p>© CalTech All Rights Reserved.</p>
                </div>
              </Container>
              <Container sx={{ width: '40%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <form onSubmit={handleLoginSubmit}>
                  { t_autherror ? <div>{t_errormsg}</div> : <></>}
                  <FormControl margin="normal" required fullWidth>
                    <BrowserNotice/> 
                    <TextField required id="t_userid" label="KOA Username" value={t_userid} onChange={(e) => { setUserid(e.target.value); setUserType(detectUserType(e.target.value)) }} />
                    {t_usertype ? <span style={{ display: "block", fontSize: '0.8em', backgroundColor: 'rgb(17 12 12)', padding: '0 1em', position: 'absolute', border: "1px solid", right: "0", borderRadius: "0.5em 0.5em 0 0", top: "-1em" }}>Detected <em> {t_usertype}</em> </span> : ""}
                  </FormControl>
                  <FormControl margin="normal" required fullWidth>
                    <TextField required id="t_password" label="Password" type="password" value={t_password} onChange={(e) => setPassword(e.target.value)} />
                  </FormControl>
                  <FormControl margin="normal" required fullWidth>
                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      className="btn btn-lg"
                      disabled={loading}
                    >Login
                    </Button>
                  </FormControl>
                  <Container>
                  </Container>
                </form>
              </Container>
            </Paper>
          </Grid>
          <FooterBar />
        </main>
      </>
      )
  );
};

export default Login;
